interface StartSessionButtonProps {
  onClick: () => void;
  label?: string;
}

export default function StartSessionButton({
  onClick,
  label = 'Start Session',
}: StartSessionButtonProps) {
  return (
    <div className="flex justify-end">
      <button
        type="button"
        onClick={onClick}
        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium"
      >
        {label}
      </button>
    </div>
  );
}
